export type TypeComponentName =
	| "headerImage"
	| "line1"
	| "line2"
	| "button1"
	| "button2"
	| "button3"
	| "tag"
	| "html"
	| "ellipsis";

export type TypeComponent = "image" | "text" | "button";

export type TypeButton = "primary" | "secondary" | "normal";

export type TypeObjectFit = "fill" | "contain" | "cover" | "none" | "scale-down";

export type TypeImagePosition = "top-middle" | "left-top" | "left-middle" | "right-top" | "right-middle";

export type TypeLayout = "carousel" | "list";

export type TypeStructure = "bubble" | "card" | "modal";

export type TypeTagPosition = "top-left" | "top-right" | "bottom-left" | "bottom-right";

export type TypeStatusAPI = "success" | "fail";

export type TypeTicketInfo = "event_name" | "show_detail" | "cost_detail" | "total_cost";

export type TypePageState =
	| "ticket-summary"
	| "contact-info"
	| "billing-address"
	| "payment-form"
	| "loading-ticket"
	| "loading-payment-status"
	| "payment-failed"
	| "payment-success"
	| "server-down"
	| "over-all-summary";

export type TypePaymentProviders = "Braintree" | "Spreedly" | "Adyen";

export type TypeVendors = "telecharge" | "ticketmaster" | "ticketscom" | "axs" | "ingresso" | "ventrata";

export type TypeActionContact = "UPDATE_CONTACT" | "GET_BOOKING_DETAIL";

export type TypeMessageForm = "header_text" | "header_image" | "footer_text" | "number_spinner";

export type TypeMessageAdmin = "admin_login" | "admin_logout";

export type TypeMessage =
	| TypeMessageForm
	| TypeMessageAdmin
	| "text"
	| "image"
	| "line"
	| "break"
	| "button"
	| "link"
	| "form";

export type TypeClickAction = "webView" | "in_app_link" | "web_link";

export type TypeDevice = "pc" | "mobile" | "pc_low";

export type TypeEventsChat =
	| "scroll_chat_to_bottom"
	| "set_config"
	| "show_typing_indicator"
	| "show_processing_message"
	| "processing_display_icon"
	| "processing_display_text"
	| "button_click"
	| "new_message"
	| "check_for_disable_input"
	| "connect_signalr"
	| "stop_signalr"
	| "prepend_message"
	| "new_message_sent"
	| "message_from_maintain_state"
	| "check_for_duplicate_iframe"
	| "scroll_to_new_message_top"
	| "remove_all_buttons"
	| "focus_input_area"
	| "blur_input_area"
	| "scroll_chat_to_top"
	| "url_opened_in_iframe"
	| "url_opened_in_iframe_from_main"
	| "hide_close_iframe_icon"
	| "remove_data_from_redis"
	| "chat_bubble_image_loaded"
	| "clear_admin_mode_input"
	| "update_admin_modal_step"
	| "validation_change"
	| "form_button_click";

export type TypeLinkTarget = "newTab" | "sameTab";

export type TypeMessageLayout = "vertical" | "horizontal" | "carousel" | "list";

export type TypeMessageStructure = "bubble" | "card" | "modal" | "time" | "fetch_msg" | "structured";

export type TypeMessageSender = "bot" | "user" | "agent" | "timestamp";

export type TypeSignalRStatus = "connected" | "disconnected" | "connecting";

export type TypeDisplayTyping = "icon";

export type TypeStoreAction = "initConfig" | "addPrevMessages" | "refreshToken" | "callAutoRefresh";

export type TypeStoreEvents =
	| "addMessage"
	| "updateMessageStatus"
	| "setUserId"
	| "setIsConfigLoaded"
	| "setBotId"
	| "setCompanyId"
	| "setCompanyToken"
	| "setSendMsgUrl"
	| "setMaintainState"
	| "setMessages"
	| "setShowInfoPanel"
	| "setErrorMessage"
	| "setShowTypingIndicator"
	| "setShowProcessingMessage"
	| "setProcessingDisplayIcon"
	| "setProcessingDisplayText"
	| "removeAllButtons"
	| "setIsBotHasAvatar"
	| "setConvId"
	| "setPageId"
	| "setLastMessageId"
	| "setShouldShowBanner"
	| "addGeneralTimeStamp"
	| "addFetchMsgTimeStamp"
	| "addPrevMessages"
	| "removeStampMessage"
	| "setIsAppInAdaMode"
	| "prependMessages"
	| "prependTimeStamp"
	| "removeMessage"
	| "SetRetryWarningCount"
	| "SetRetryWarningInterval"
	| "updateMessageCacheID"
	| "updateMessageStructure"
	| "setIsBrowseUrlOnSametab"
	| "setIsShowHeaderInIframe"
	| "setIsHideTitleBar"
	| "setSatisfiURL"
	| "setHeaderImage"
	| "setBackgroundImage"
	| "setHeaderImageDestinationURL"
	| "setTypingMessageSecondsInterval"
	| "setTypingType"
	| "setIsUserHasAvatar"
	| "setAWSServerURL"
	| "setAWSThemeFilePath"
	| "setAWSImageLogoPath"
	| "setAWSPopupConfigPath"
	| "setPopupId"
	| "setPageReferralUrl"
	| "setDisableInput"
	| "setDefaulthideInputContainerSetting"
	| "setLastFocusableElement"
	| "setBannerText"
	| "setUserLng"
	| "setUserLat"
	| "setLocationBlocked"
	| "setUserIdSourceTypeId"
	| "clearScreen"
	| "setParentSiteUrl"
	| "setParentSiteReferralUrl"
	| "setRequestResponseReceived"
	| "setFocusedWindow"
	| "setIsSignalRConnected"
	| "setIsAnchorTagClickedSametabNewtab"
	| "setClientVersion"
	| "setMinimumClientVersion"
	| "setIsTilesOpenedInIframe"
	| "setCFHeader"
	| "setShowAdminLoginModal"
	| "setShowConsentModal"
	| "setIsAdminMode"
	| "setEnableAdminMode"
	| "setShowModal"
	| "setWebApiAddress"
	| "setDashboardAddress"
	| "setAttemptNoofInvalidCode"
	| "setAttemptNoofResendCode"
	| "setMFAExpiration"
	| "setMFAEnableDateTime"
	| "setAuthToken"
	| "setAuthTokenExpiration"
	| "setIsMFAEnabled"
	| "setRefreshTask"
	| "setIsTermsConsentEnabled"
	| "setTermsConsentPayload"
	| "setTermsConsentExpiration"
	| "setIsFirstUserMessage"
	| "setConsentStatusOptions"
	| "setIsTermsOfServiceAccepted"
	| "setFormInput"
	| "clearFormInputs"
	| "setShowWelcomeBanner"
	| "setIsNewMessageProcessing"
	| "setIsMaintainStateMessages"
	| "setEnableMessageNavigation"
	| "setFormItemChange"
	| "setFormButtonOptions";

export type TypeLoading = "default" | "ripple" | "dual-ring" | "spinner";

export type TypePostBackAction = "process" | "track";

export type TypePostBackType = "posback" | "postback" | "text";

export type TypeTagOrientation = "card" | "image" | "content" | "button";
